import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// ng2-pdf-viewer falls back to loading pdf.worker.min.js from cdn.jsdelivr.net unless this is set
// before the first `<pdf-viewer>` instantiates. Must run before bootstrap.
(window as unknown as { pdfWorkerSrc: string }).pdfWorkerSrc = 'assets/pdfjs/pdf.worker.min.js';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
